export default __webpack_public_path__ + "static/media/reputation-personas.45763ecb.svg";